<template>
    <div class="card-container">
        <div class="flex-row vertical-center flow-justify">
            <el-button type="default" class="button-size" @click="$router.go(-1)">返回上一级</el-button>
        </div>

        <el-row class="plan-label flow-wrap">
            <p>姓名：<span>{{$route.params.name || '--'}}</span></p>
            <p>电话：<span>{{$route.params.phone}}</span></p>
        </el-row>
        <common-table :data="tableData" :isShow="false" ref="commonTable" @handleChange="getList" class="common">
            <el-table-column type="index" min-width="80" label="序号"></el-table-column>
            <el-table-column prop="ocrType" label="类型" min-width="100" :formatter="formatTranTypee" show-overflow-tooltip></el-table-column>
            <el-table-column prop="result" label="识别结果" min-width="100" show-overflow-tooltip></el-table-column>
            <el-table-column prop="createTime" label="识别时间" min-width="130" show-overflow-tooltip></el-table-column>
            <el-table-column label="操作" min-width="100">
                <template slot-scope="scope">
                    <el-button type="text" @click="handleDownload(scope.row.id)">下载</el-button>
                </template>
            </el-table-column>
        </common-table>
    </div>
</template>

<script>

    import CommonTable from 'components/common/CommonTable'

    import OrganService from 'service/OrganService'
    import ChannelRateService from 'service/ChannelRateService'
    import TransactionService from 'service/TransactionService'
    import privateKey from 'service/constant/privateKey'
    import ocrType from 'service/constant/ocrType'
    import {encrypt, urlEncode, objKeySort} from "common/js/common-utils";
    import {loadMixin, dialogMixin, validatorsMixin} from "mixin";
    import {mapGetters} from 'vuex'

    export default {
        name: "TestimoneyDetails",
        data() {
            return {
                notice: {},
                tableData: [],
                page: {},
                ocrType: ocrType,
                planStatus: [],
                showBut: false,
                currentStatus: '',
                consumeMoney:0,
            }
        },
        mixins: [loadMixin, dialogMixin, validatorsMixin],
        components: {
            CommonTable
        },
        mounted() {
            // this.page = this.$refs.commonTable.page;
            this.getList();

            this.getTypeNames('计划状态', (res) => {
                this.planStatus = res;
            });
        },
        computed: {
            commonParams() {
                const params = {
                    userId: this.userId,
                    memId: this.$route.params.id,
                };
                return params;
            },
            ...mapGetters(['serverType', 'tatId', 'userId'])
        },
        inject: ['reload','addTab'],
        methods: {
            formatTranTypee(row, column, cellValue) {
                let value = '';
                value = this.ocrType[cellValue];
                return value ? value : '--';
            },
            getList() {
                this.doLoad(TransactionService.ocrAuthGetDetail, this.commonParams, res => {
                    this.doCheck(res, res => {
                        const result = res.contents;
                        this.tableData = result;
                    });
                }, '信息获取失败')
            },
            handleDownload(id){
                TransactionService.exportFile({
                    id : id
                })
            },
        }

    }
</script>

<style scoped>
    .plan-label {
        /*padding-left: 10%;*/
        justify-content: flex-start;
    }

    .plan-label p {
        margin: 10px 10px 20px;
    }

    .plan-label p span {
        color: rgba(170, 170, 170, 1);
    }

    .button-size {
        width: 120px;
        margin-bottom: 30px;
    }

</style>



// WEBPACK FOOTER //
// src/view/page/ToolsManage/TestimoneyDetails.vue